import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NextButton } from 'components/next-button';

import { useStyles } from './styles';

interface MobileContentProps {
    isIosDevice: boolean;
    isUserActive: boolean;
    email: string;
    handleClick: () => void;
}

export const MobileContent: FC<MobileContentProps> = ({ isIosDevice, isUserActive, email, handleClick }) => {
    const { t } = useTranslation();

    const {
        welcomeMobileInfoWrapper,
        title,
        subtitle,
        listWrapper,
        list,
        listItem,
        suggestionIfUserExists,
        info,
    } = useStyles();

    const welcomeTitleKey = isIosDevice ? 'welcome-title' : 'welcome-title-android';
    const appName = isIosDevice ? t('welcome-list-text-mobile-download-app-ios-name') : t('welcome-instructions-able-app-name');
    const ableAppName = isIosDevice ? null : t('welcome-instructions-able-app-name');
    const downloadButtonAppName = isIosDevice ? t('welcome-button-next-ios-app-name') : t('welcome-instructions-able-app-name');

    return (
        <div className={welcomeMobileInfoWrapper}>
            <h1 className={`${isIosDevice && title}`}>
                {!isUserActive && t(welcomeTitleKey)}
                {isUserActive && t('welcome-title-if-user-exists')}
            </h1>
            {isIosDevice && <h2 className={subtitle}>
                {t('welcome-subtitle-ios')}
            </h2>}

            <div className={listWrapper}>
                <h2 className={listItem}>
                    {!isUserActive && t('welcome-instructions-title', { ableAppName })}
                    {isUserActive && t('welcome-subtitle-mobile-if-user-exists')}
                </h2>
                <ol className={list}>
                    <h2 className={listItem}>
                        <li>
                            {t('welcome-list-text-mobile-download-app', { appName })}
                        </li>
                    </h2>
                    <h2 className={listItem}>
                        <li>
                            {!isUserActive && t('welcome-list-text-mobile-open-app', { email })}
                            {isUserActive && t('welcome-list-text-mobile-open-app-if-user-exists', { email })}
                        </li>
                    </h2>

                    {!isUserActive &&
                        <h2 className={listItem}>
                            <li>
                                {t('welcome-list-text-mobile-create-password')}
                            </li>
                        </h2>
                    }

                </ol>
            </div>

            {isUserActive &&
                <h2 className={suggestionIfUserExists}>
                    {t('welcome-text-mobile-suggestion-if-user-exists')}
                </h2>
            }

            {isIosDevice && <p className={info}>
                {t('welcome-ios-info')}
            </p>}

            <NextButton
                bottomMargin
                onClick={handleClick}
                typographyText={t('welcome-button-next', { downloadButtonAppName })}
            />
        </div>
    );
};
